import { injectIntl } from 'react-intl';
import { compose, withHandlers } from 'recompose';
import moment from 'moment';
import { connect } from 'react-redux';
import { getTotalsByDate, getCostByDate } from 'redux/modules/journeys/selectors';
import { getAssignedFilters } from 'redux/modules/jobs/selectors';
import { setJobsSummaryModalOpen } from 'redux/modules/journeys/duck';

import DateTitleWithCost from './component';

const actionCreators = {
  setJobsSummaryModalOpen,
};

const enhance = compose(
  injectIntl,
  connect((state, { date, selectors }) => {
    const totalsByDate = getTotalsByDate(state);
    const costByDate = getCostByDate(state);
    const assignedFilters = getAssignedFilters(state);

    return {
      numberOfItems: totalsByDate[date],
      totalCost: costByDate && costByDate[date] ? costByDate[date].amount : null,
      totalCostCurrency: costByDate && costByDate[date] ? costByDate[date].currency : null,
      shipperFilter: assignedFilters && assignedFilters.shipper ? assignedFilters.shipper : null,
    };
  }, actionCreators),
  withHandlers({
    handleOpenJobsSummaryModal:
      ({ setJobsSummaryModalOpen, date, shipperFilter }) =>
      () => {
        const { id } = shipperFilter;
        setJobsSummaryModalOpen({
          date: moment(date).format('YYYY-MM-DD'),
          shipperId: id,
        });
      },
  })
);

export default enhance(DateTitleWithCost);
